export const SOFTLINE_API_PMS_MELDUNGEN = 'v1/pms/pmsmeldung/entities/{{idlstfix}}';